import { render, staticRenderFns } from "./data_source.vue?vue&type=template&id=64e7175b&scoped=true"
import script from "./data_source.vue?vue&type=script&lang=js"
export * from "./data_source.vue?vue&type=script&lang=js"
import style0 from "./data_source.vue?vue&type=style&index=0&id=64e7175b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e7175b",
  null
  
)

export default component.exports